import { Box, Grid, Popover, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

import DoneIcon from '../../../../packages/common/shared-ui/src/icons/DoneIcon';

const StyledContextPopover = styled(Popover, {
  shouldForwardProp: prop =>
    ![
      'leftBottomCornerStyle',
      'leftUpperCornerStyle',
      'leftSideCornersStyle',
    ].includes(prop),
})(
  ({
    theme,
    leftBottomCornerStyle,
    leftUpperCornerStyle,
    leftSideCornersStyle,
  }) => ({
    transform: 'unset !important',
    height: 'fit-content',
    borderRadius: theme.spacing(4),
    ...(leftBottomCornerStyle && {
      borderRadius: theme.spacing(4, 4, 4, 0),
    }),
    ...(leftUpperCornerStyle && {
      borderRadius: theme.spacing(0, 4, 4, 4),
    }),
    ...(leftSideCornersStyle && {
      borderRadius: theme.spacing(0, 4, 4, 0),
    }),
    '& .MuiPaper-root': {
      overflowY: 'hidden',
      maxWidth: 'unset',
      maxHeight: 'unset',
      width: '100%',
      borderRadius: theme.spacing(4),
      ...(leftBottomCornerStyle && {
        borderRadius: theme.spacing(4, 4, 4, 0),
      }),
      ...(leftUpperCornerStyle && {
        borderRadius: theme.spacing(0, 4, 4, 4),
      }),
      ...(leftSideCornersStyle && {
        borderRadius: theme.spacing(0, 4, 4, 0),
      }),
      boxShadow: 'rgb(0 0 0 / 70%) 5px 3px 12px -8px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#F1F2F8',
      marginRight: '2px',
    },
    '&::-webkit-scrollbar': {
      width: '4px',
      backgroundColor: 'white !important',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#7174AC',
      borderRadius: '5px',
    },
    '& .MuiBackdrop-root': {
      display: 'none',
      position: 'unset',
    },
  }),
);
const StyledContextMenuSubItem = styled(Grid)(({ theme }) => ({
  borderRadius: theme.spacing(0, 4, 4, 0),
  padding: theme.spacing(1.5, 0),
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'rgba(220, 223, 244, 1)',
    borderRadius: 0,
  },
}));
const TableSecondStepPopover = ({
  value,
  type,
  data,
  isSecondStepVisible,
  contextPopperStylePosition,
  handleChooseSubItem,
  positionInfo = {
    itemPosition: 1,
    positionDelta: 1,
    totalCount: 3,
  },
}) => {
  return (
    <StyledContextPopover
      leftBottomCornerStyle={
        positionInfo.itemPosition === 0 && positionInfo.positionDelta > 0
      }
      leftUpperCornerStyle={
        positionInfo.itemPosition !== 0 && positionInfo.positionDelta <= 0
      }
      leftSideCornersStyle={
        positionInfo.itemPosition !== 0 && positionInfo.positionDelta > 0
      }
      open={!!isSecondStepVisible}
      style={{
        left: contextPopperStylePosition.current.left + 182,
        top:
          contextPopperStylePosition.current.top +
          positionInfo.itemPosition * 32,
        maxWidth: 180,
        height: positionInfo.totalCount < 8 ? 'auto' : 230,
        overflowY: 'auto',
        boxShadow:
          positionInfo.totalCount > 8
            ? '0px 5px 10px -8px rgba(33, 35, 70, 1)'
            : 'none',
      }}
      anchorPosition={contextPopperStylePosition.current}
      anchorReference='none'
      keepMounted
    >
      <Grid container direction='column'>
        {value?.map((item, index) => {
          return (
            <StyledContextMenuSubItem
              container
              wrap='nowrap'
              key={index}
              onClick={() => handleChooseSubItem(item.valueId, type)}
              data-value='approve'
              sx={{
                alignItems: 'center',
              }}
            >
              {item.isChecked && (
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                  }}
                >
                  <DoneIcon color='rgba(55, 198, 112, 1)' viewBox='0 0 24 24' />
                </Box>
              )}
              <Typography
                variant='h5'
                sx={{
                  paddingLeft: item.isChecked ? 1 : 5,
                }}
              >
                {item.valueName}
              </Typography>
            </StyledContextMenuSubItem>
          );
        })}
      </Grid>
    </StyledContextPopover>
  );
};

export default TableSecondStepPopover;
